import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QREditorLayoutTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/QrEditorTemplates/qr-layout/qr-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QREditorSelectorTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/QrEditorTemplates/qr-selector/qr-selector.tsx");
